import { ComponentIds, ValidationResultFail, } from "@inter-ikea-core/core";
import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { getEntityBlockConnectionHoleComponent } from "@inter-ikea-storagetwo/range/dist/functions/blockConnectionHole";
import { getEntityHolesOccupied, getEntityProductRef, } from "@inter-ikea-storagetwo/range/dist/utils/entityUtils";
import { entityIsSection } from "@inter-ikea-storagetwo/range/dist/functions/attachedTo";
export class CabinetPlacementRestrictionValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.name = "CabinetPlacementRestrictionValidation";
        this.id = "CABINET_PLACEMENT_RESTRICTION_VALIDATION";
        /**
         * Checks if the current entity is a cabinet
         * @param entity
         * @returns
         */
        this.isCabinet = (entity) => {
            var _a;
            const templateId = (_a = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.templateId;
            if (!templateId)
                throw new Error("Entity is missing Template Data");
            return templateId.includes("cabinet");
        };
        /**
         * Get how many connection holes exist in a section
         * @param host
         * @returns
         */
        this.getConnectionHolesInSection = (host) => {
            var _a;
            return ((_a = host
                .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connectors.find((connector) => connector.key === "insert-connector")).subConnectorCount;
        };
    }
    validateCurrentState(_entity) {
        return null;
    }
    /**
     * Validates if the cabinet can be placed at the top or bottom connection hole
     * @param entity
     * @param Snap
     * @returns
     */
    validateCabinetPlacement(entity, Snap) {
        const SnapHole = Snap.hostConnector.hole;
        const host = Snap.host;
        if (!host || !entityIsSection(host))
            return null;
        const entityHolesOccupied = getEntityHolesOccupied(entity) - 1;
        const entityBlockConnectionHoleComponent = getEntityBlockConnectionHoleComponent(entity);
        if (!entityBlockConnectionHoleComponent)
            return null;
        const holesToBlock = [
            this.getConnectionHolesInSection(host) -
                entityBlockConnectionHoleComponent.blockHoleAbove,
            0,
        ];
        return holesToBlock.includes(SnapHole) ||
            holesToBlock.includes(SnapHole - entityHolesOccupied)
            ? new ValidationResultFail("Can not place cabinet at top or bottom of section", getEntityProductRef(entity))
            : null;
    }
    validateSnap(_Snap) {
        const entity = _Snap.guestRoot;
        if (!this.isCabinet(entity))
            return null;
        return this.validateCabinetPlacement(entity, _Snap);
    }
}
